<template>
  <v-container fluid class="Step-container overflow-x-auto">
    <v-row>
      <v-col class="Container-head pa-0" cols="3" sm="2" md="1">
        <div class="Row-label">{{ $t('weekOpening.day') }}</div>
        <div class="Row-start">{{ $t('weekOpening.open') }}</div>
        <div class="Row-end">{{ $t('weekOpening.close') }}</div>
        <div class="WeekOpening--small">
          {{ $t('weekOpening.slotMaximum') }}
          <div class="WeekOpenings-tooltips">
            <div class="WeekOpenings-tooltipButton">i</div>
            <div class="WeekOpenings-tooltipsContent">
              {{ $t('weekOpening.tooltipMessage') }}
            </div>
          </div>
        </div>
      </v-col>
      <DaySchedule
        v-for="schedule in openings"
        :key="schedule.key"
        :availableHours="availableHours"
        :schedule="schedule"
        class="px-1"
      />
    </v-row>
  </v-container>
</template>

<script>
import DaySchedule from '@/components/onboarding/UI/DaySchedule'
import { rangeTime } from '@/services/time'

export default {
  name: 'WeekOpenings',

  components: { DaySchedule },

  model: {
    prop: 'openings',
    event: 'change'
  },

  props: {
    openings: {
      type: Array,
      required: true
    }
  },

  computed: {
    availableHours() {
      return rangeTime(0, 23.5, 0.5)
    },
    hasOneDayActive() {
      return this.openings.some(opening => opening.active)
    }
  }
}
</script>

<style scoped lang="scss">
.Step-container {
  > .row:nth-child(1) {
    flex-wrap: nowrap;
  }
}

.Container-head {
  padding-right: 25px;
  margin-top: 5px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  font-size: 0.9rem;
  > * {
    margin: 5px 0;
    word-break: break-all;
  }
}

.Row-label {
  height: 40px;
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 30px;
  padding-top: 4px;
}

.Row-start,
.Row-end {
  display: flex;
  justify-content: left;
  height: 40px;
  padding-top: 4px;
}

.WeekOpening--small {
  display: flex;
  position: relative;
  font-size: 0.9rem;
}

.WeekOpenings-tooltips {
  .WeekOpenings-tooltipButton {
    flex-shrink: 1;
    top: 0;
    right: -1.4rem;
    display: block;
    width: 1.2rem;
    height: 1.2rem;
    font-size: 0.8rem;
    font-weight: bold;
    border-radius: 50%;
    text-align: center;
    line-height: 1.2rem;
    color: #fff;
    background: rgba(61, 66, 77, 0.9);
    margin-left: 5px;
  }

  .WeekOpenings-tooltipsContent {
    display: none;
    position: absolute;
    bottom: 0;
    left: calc(100% + 20px);
    color: var(--v-text-base);
    font-weight: normal;
    font-size: 0.9rem;
    z-index: 10;
    min-height: 60px;
    width: 270px;
    text-align: left;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 10px 15px;
  }

  &:hover .WeekOpenings-tooltipsContent {
    display: block;
  }
}
</style>

<style lang="scss">
.App-galileo .WeekOpenings-tooltips {
  .WeekOpenings-tooltipButton {
    background: var(--v-primary-base);
  }
}
</style>